<template>
  <div class="pa-0">
    <ListLayout
      title="Vehicle Type"
      :context="context"
      :tableData="tableData"
      :tableHeader="columnDefs"
      :total="totalItems"
      :hasAfterTitle="false"
      :hasListActions="true"
      @getList="getVehicleTypeList"
      ref="vehicleType"
    >
      <template #listAction>
        <PrimaryButton
          id="wAdd"
          name="Add"
          icon="mdi-plus"
          iconSize="x-large"
          @click="openFormDialog"
        >
        </PrimaryButton>
      </template>
      <template #dialogs>
        <VehicleTypeForm
          v-model="openVehicleTypeDialog"
          @refreshList="getFetchList"
          :objectID="objectID"
          @reset="objectID = null"
          :editMode="editMode"
        />
      </template>
    </ListLayout>
  </div>
</template>

<script>
import { bus } from "@/main.js";
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import VehicleTypeForm from "@/components/ModuleBasedComponents/adminConfiguration/VehicleTypeForm.vue";
import ConfigurationVehicleTypeButton from "@/components/Button/ConfigurationVehicleTypeButton.vue";

export default {
  components: {
    ConfigurationVehicleTypeButton,
    ListLayout,
    BaseDialog,
    VehicleTypeForm,
  },
  data() {
    return {
      openVehicleTypeDialog: false,
      totalItems: 0,
      colDef: [],
      tableData: [],
      objectID: null,
      editMode: false,
    };
  },
  computed: {
    context() {
      return { parentComponent: this };
    },
    columnDefs() {
      return [
        ...this.colDef,
        {
          headerName: "Name",
          field: "name",
          flex: 1,
        },
        {
          headerName: "Length",
          field: "length",
          flex: 1,
        },
        {
          headerName: "Height",
          field: "height",
          flex: 1,
        },
        {
          headerName: "Width",
          field: "width",
          flex: 1,
        },
        {
          headerName: "CBM Capacity",
          field: "cbm_capacity",
          flex: 1,
        },
        {
          headerName: "Tonnage Capacity",
          field: "tonnage_capacity",
          flex: 1,
        },
        {
          headerName: "Actions",
          width: 100,
          minWidth: 100,
          field: "actions",
          pinned: "right",
          cellRenderer: "ConfigurationVehicleTypeButton",
        },
      ];
    },
  },
  methods: {
    getFetchList() {
      this.$refs.vehicleType.itemsPerPageChanged(
        this.$globalConstant.itemsPerPage
      );
    },
    editForm(id) {
      this.editMode = true;
      this.objectID = id;
      this.openVehicleTypeDialog = true;
    },
    openFormDialog() {
      this.editMode = false;
      this.openVehicleTypeDialog = true;
    },
    getVehicleTypeList(params = {}) {
      bus.$emit("showLoader", true);
      this.$api.vehicleType
        .getVehicleTypeList(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.tableData = res.data;
          this.totalItems = res.count;
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          console.log(err);
        });
    },
  },
};
</script>